import React from 'react';

const data = [
  {
    category: 'Merchandising Teams',
    tier1:
      'Buyers, planners, and allocators working full-time with AI support.',
    tier3: 'You, maybe a family member — wearing every hat, every day.',
  },
  {
    category: 'Pricing Strategy',
    tier1:
      'Algorithms adjust prices based on inventory velocity and margin goals.',
    tier3:
      'Manual guesses or matching what the store across the street charges.',
  },
  {
    category: 'Vendor Relationships',
    tier1:
      'Direct integrations, rebates, freight optimization, and bracket pricing.',
    tier3: 'Local reps, handwritten invoices, and limited negotiation power.',
  },
  {
    category: 'Inventory Management',
    tier1: 'Just-in-time replenishment powered by predictive analytics.',
    tier3: 'Walk the aisles and guess what needs to be reordered.',
  },
  {
    category: 'Analytics & Reporting',
    tier1: 'Daily dashboards, store clustering, item-level insights.',
    tier3: 'At best, a POS report printed once a month — if that.',
  },
];

const ComparisonTable = () => {
  return (
    <section className="bg-soft-earth py-12 px-4 md:px-20">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-2xl font-bold text-center text-primary mb-10">
          A Side-by-Side Reality Check
        </h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-cool-gray shadow-md rounded overflow-hidden text-left">
            <thead className="bg-cool-gray text-gray-700 text-sm uppercase">
              <tr>
                <th className="p-4 w-1/4">Category</th>
                <th className="p-4 w-1/2 text-rosewood">Tier 1 Retailer</th>
                <th className="p-4 w-1/2 text-deep-navy">
                  Independent Retailer
                </th>
              </tr>
            </thead>
            <tbody className="text-gray-800 text-base">
              {data.map((row, index) => (
                <tr
                  key={index}
                  className="border-t border-cool-gray"
                >
                  <td className="p-4 font-semibold text-gray-600">
                    {row.category}
                  </td>
                  <td className="p-4">{row.tier1}</td>
                  <td className="p-4">{row.tier3}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
